


























import { Component } from 'vue-property-decorator';
import * as api from '@/api';
import { PaginationMixin } from '@/utils/mixin';
import { pick, cloneDeep } from 'lodash';
import { State } from 'vuex-class';

/**
 * 绑定目录列表
 *
 * @author liyuyao
 * @date 07/03/2020
 */
@Component
export default class RgUser extends PaginationMixin {
    @State(state => state.cti.permission.rg_catalog)
    permission: boolean;

    catalogList: CommonTypes.RgUserItem[] = [];
    rgId: number = 0;
    tableLoading: Boolean = false;
    $mtd: any;

    created() {
        this.rgId = parseInt(this.$route.query.rgId as string, 10);
        this.getCtiByRgUnfold();
        // this.getCategoryTreeByRg(this.rgId);
    }
    handleChange(current: number, size: number) {
        this.limit = size;
        this.currentPage = current;
        this.getCtiByRgUnfold();
    }
    async getCtiByRgUnfold() {
        try {
            const res = await api.rgApi.getCtiByRgUnfold({
                cn: this.currentPage,
                sn: this.limit,
                rgId: this.rgId
            });
            const { code, data } = res;
            if (code === 200) {
                this.total = data.tn;
                if (this.total > 0 && !data.items.length) {
                    this.currentPage -= 1;
                    if (this.currentPage <= 0) {
                        this.currentPage = 1;
                    }
                    this.getCtiByRgUnfold();
                }
                this.catalogList = res.data.items;
            }
        } catch (e) {
            console.log(e);
        }
    }
    // 树转平铺列表，暂时废弃
    async getCategoryTreeByRg(rgId: number) {
        try {
            const res = await api.ctiApi.getCategoryTreeByRg(rgId);
            const { code } = res;
            if (code === 200) {
                // this.catalogList = res.data.items;
                this.flatNodes(res.data.items, {});
            }
        } catch (e) {
            console.log(e);
        }
    }
    flatNodes(nodes, fromObj) {
        nodes.forEach(node => {
            const keys = Object.keys(node).filter(item => item !== 'children');
            const obj = pick(node, keys);
            const resObj = Object.assign(fromObj, obj);
            if (node.children) {
                this.flatNodes(node.children, resObj);
            } else {
                this.catalogList.push(cloneDeep(resObj));
            }
        });
    }
}
